import { inject } from "@angular/core";
import { type CanActivateFn, Router, type UrlTree } from "@angular/router";

import { AuthService } from "../services/auth.service";

/**
 * Route guard. Allows navigation when the user is authenticated. A user who is
 * signed in but lacks a required role is sent to /unauthorized (access not
 * provisioned) — routing them to /login would loop, since signing in again
 * yields the same role-less account. A user with no account goes to /login,
 * where the SSO sign-in is triggered.
 */
export const authGuard: CanActivateFn = (): boolean | UrlTree => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    return true;
  }
  if (auth.hasAccount()) {
    return router.parseUrl("/unauthorized");
  }
  return router.parseUrl("/login");
};
